<template>
  <div class="stats">
    <BaseButtonExpand class="close" state="close" @click.native="$emit('close')"/>
    <div class="stats-container">
      <div class="stats-header-main">
        <BaseOpponentLabel :opponent-label="opponent.alias" v-if="opponent.alias"/>
        <BaseText11 :text="opponent.firstName + '<br>' + opponent.lastName"/>
      </div>
      <div class="stats-main">
        <div class="stats-column">
          <Records
            :opponent-flag="opponent.flagImage"
            :opponent-rank="opponent.rank"
            :opponent-image="opponent.image3"
            :opponent-win-loss="opponent.winLossRatio"
            :opponent-total-fights="opponent.totalFights"
            :opponent-wins="opponent.wins"
            :opponent-losses="opponent.losses"
            :opponent-reach="opponent.reach"
            :opponent-mma-record="opponent.mmaRecord"
            :opponent-knockouts="opponent.knockouts"
            :opponent-background-colour="opponent.rankBackgroundColour"
            :opponent-text-colour="opponent.rankTextColour"
          />
        </div>
        <div class="stats-column">
          <Biography
            :opponent-hometown="opponent.hometown"
            :opponent-age="opponent.age"
            :opponent-height="opponent.height"
            :opponent-weight="opponent.weight"
          />
          <Divider/>
          <Story
            :opponent-story="opponent.story"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseText11 from '@/components/BaseText11/BaseText11'
import BaseOpponentLabel from '@/components/BaseOpponentLabel/BaseOpponentLabel'
import BaseButtonExpand from '@/components/BaseButtonExpand/BaseButtonExpand'
import Records from './partials/Records/Records'
import Biography from './partials/Biography/Biography'
import Divider from './components/Divider/Divider'
import Story from './partials/Story/Story'
import { calcFilteredAverages } from '@/utils/emotionSeriesUtils'
export default {
  components: {
    BaseText11,
    BaseOpponentLabel,
    BaseButtonExpand,
    Biography,
    Records,
    Divider,
    Story
  },
  props: {
    opponent: {
      type: Object,
      required: true
    }
  },
  computed: {
    opponentEmotionAveragesFiltered () {
      return calcFilteredAverages(this.opponent.emotionSeries)
    }
  }
}
</script>

<style lang="scss" scoped>
.stats {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
}
.stats-header-main {
  text-align: left;
}
.stats-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 90rem;
  margin: auto;
  padding: var(--spacing-1);
}
.stats-main {
  display: flex;
  align-items: flex-start;
  margin-top: 4rem;
}
.stats-column {
  width: 100%;
}
.close {
  position: abolute;
  left: 50%;
  transform: translate(-50%);
  top: var(--spacing-1);
  z-index: 1;
}
</style>
